<button id="chatEjecutivo" #chatEjecutivo type="button" [disabled]="disable" [matBadge]="total != 0 ? total : ''" matBadgeColor="warn" (click)="openChat()" class="chat-bubble primary-button">
    <i class="fa-regular fa-message-lines"></i>
    <input class="no-input label-chat" value="Conversa con tu ejecutivo" readonly>
</button>
